import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { isGiftingHomePage } from 'Utils/PathVerification';
import { PrimaryFooterContainer } from './PrimaryFooterContainer';
import { LightFooter } from './LightFooter';

export const Footer = ({ path = '' }) => {
  const { showLightFooter = false } = useSelector((s) => s.purchaseMode);
  return showLightFooter && !isGiftingHomePage(path) ? <LightFooter /> : <PrimaryFooterContainer pathname={path} />;
};
